<div
	class="notifications-btn"
	*ngIf="!dismiss && !hasNotifyPermission && !isSafari"
	[@HideNotificationBtn]
	[@pressState]="buttonState"
	appCrossPointerEventTarget
	(pointerClickEvent)="buttonDown = false; onClick()"
	(pointerDownEvent)="buttonDown = true"
	(pointerCancelEvent)="buttonDown = false"
	(mouseleave)="buttonDown = false">
	<img class="notifications-btn__cancel" [src]="'./assets/Close.svg' | resolveAsset" alt="remove notification btn" (click)="dismissClick()" />
	<div class="notifications-btn__content">
		<img class="notifications-btn__icon" [src]="'./assets/Browser Notification.svg' | resolveAsset" alt="notification icon" />
		<p class="notifications-btn__text">Turn Browser Notifications On</p>
	</div>
</div>
